import { Box, Container, Typography, Link, Grid, Divider, IconButton } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import React, { useEffect, useState } from 'react';

function Footer() {
  const location = useLocation();
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    if (location.pathname === '/') {
      try {
        const storageKey = 'scrumtherapist_home_visits';
        const stored = localStorage.getItem(storageKey);
        const currentCount = stored ? parseInt(stored, 10) || 0 : 0;
        const newCount = currentCount + 1;
        localStorage.setItem(storageKey, String(newCount));
        setVisitorCount(newCount);
      } catch (error) {
        setVisitorCount(null);
      }
    }
  }, [location.pathname]);

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[900],
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" color="primary.light" gutterBottom fontWeight="bold">
              ScrumTherapist
            </Typography>
            <Typography variant="body2" color="grey.300">
              Your 24/7 Agile Scrum consultant, helping teams solve real-time problems and improve their Agile practices.
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <IconButton size="small" sx={{ color: 'grey.400' }}>
                <GitHubIcon />
              </IconButton>
              <IconButton 
                size="small" 
                sx={{ color: 'grey.400', '&:hover': { color: 'primary.light' } }}
                component="a"
                href="https://www.linkedin.com/company/scrum-therapist/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton 
                size="small" 
                sx={{ color: 'grey.400', '&:hover': { color: 'primary.light' } }}
                component="a"
                href="https://www.facebook.com/profile.php?id=61566811777222"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton size="small" sx={{ color: 'grey.400' }}>
                <TwitterIcon />
              </IconButton>
            </Box>
            {location.pathname === '/' && visitorCount !== null && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption" color="grey.500">
                  {visitorCount.toLocaleString()} visitors have been here
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" color="primary.light" gutterBottom fontWeight="bold">
              Resources
            </Typography>
            <Link href="https://scrumguides.org/" color="grey.300" display="block" sx={{ mb: 1, '&:hover': { color: 'primary.light' } }}>
              Scrum Guide
            </Link>
            <Link href="https://agilemanifesto.org/" color="grey.300" display="block" sx={{ mb: 1, '&:hover': { color: 'primary.light' } }}>
              Agile Manifesto
            </Link>
            <Link component={RouterLink} to="/case-studies" color="grey.300" display="block" sx={{ mb: 1, '&:hover': { color: 'primary.light' } }}>
              Case Studies
            </Link>
            <Link component={RouterLink} to="/blog" color="grey.300" display="block" sx={{ mb: 1, '&:hover': { color: 'primary.light' } }}>
              Blog
            </Link>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="primary.light" gutterBottom fontWeight="bold">
              Contact Us
            </Typography>
            <Typography variant="body2" color="grey.300">
              Have feedback? We'd love to hear from you! 
            </Typography>
            <Typography variant="body2" color="grey.300" >
              Email: jenny@scrumtherapist.com                                       
            </Typography>
          </Grid>        
        </Grid>
        <Divider sx={{ my: 3, borderColor: 'grey.800' }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <Typography variant="body2" color="grey.400">
            © {new Date().getFullYear()} ScrumTherapist. All rights reserved.
          </Typography>
          <Box>
            <Link 
              component={RouterLink} 
              to="/privacy-policy" 
              color="grey.400" 
              sx={{ mx: 1, '&:hover': { color: 'primary.light' } }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms-and-conditions" 
              color="grey.400" 
              sx={{ mx: 1, '&:hover': { color: 'primary.light' } }}
            >
              Terms and Conditions
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
